import { ResponseData } from "@/typings";
import { fetchTrackApi } from "@/utils/fetch";
import { GetTrackingRecordSaveParams } from "./interface";
import { TrackingPlatform, UtmList } from "@/shared";
import { clientWindow, isServerRendering } from "@/utils/dom";
import { getUriQuery } from "@/utils/url";
import { generateFingerprint } from "@/utils/deviceInfo";
import { getUid } from "@/utils/get-app-info";
import { isInApp, isMobile } from "@/utils/is";

const getPlatform = () => {
  if (isInApp()) {
    return TrackingPlatform.App;
  }
  if (isMobile()) {
    return TrackingPlatform.H5;
  } else {
    return TrackingPlatform.Pc;
  }
};
const trackingRecordSaveParams = {
  platform: getPlatform(),
  report_time: Math.floor(new Date().getTime() / 1000),
};

export const utmData = () => {
  const url = clientWindow?.location?.href || "";
  const [, search] = url.split("?");
  const urlQuery = getUriQuery(search || "", UtmList);
  return urlQuery;
};

const extUrlData = (params: GetTrackingRecordSaveParams) => {
  const url = clientWindow?.location?.href || "";
  const utmQuery = utmData();
  const { ext } = params;
  const newExt = { ...utmQuery, url, ...ext };
  return newExt;
};

export async function fetchTrackingRecordSave(
  params: GetTrackingRecordSaveParams
) {
  const deviceId = isServerRendering ? "" : await generateFingerprint();
  const uid = await getUid();
  return fetchTrackApi<ResponseData<null>>("v1/tracking-record/save", {
    method: "POST",
    body: JSON.stringify({
      ...trackingRecordSaveParams,
      ...params,
      ...utmData(),
      uid: uid || "",
      ext: JSON.stringify(extUrlData(params)),
      device_id: deviceId,
    }),
  });
}
